import React, { useContext } from 'react'
import { HiOutlineShoppingCart } from "react-icons/hi2";
import { CiSearch } from "react-icons/ci";
import { CiHeart } from "react-icons/ci";
import "./Nav.scss"
import { Link } from 'react-router-dom';
import { LocationContext } from '../../Context/UserLocation';


export default function Nav() {

    const { setSearchShow, SearchShow } = useContext(LocationContext)

    return <nav className='bottom-nav flex justify-between items-center z-10'>
        <ul>
            <li>
                <Link to="/Cart">
                    <HiOutlineShoppingCart />
                </Link>
            </li>
            <li>
                <Link to='/Favourits'>
                    <CiHeart />
                </Link>
            </li>
            <li onClick={() => setSearchShow(!SearchShow)}><CiSearch /></li>
        </ul>
    </nav>
}
